import Vimeo from '@vimeo/player';

export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS

       if($('#video-vimeo').length > 0){
           const vimeoID = $('#video-vimeo').data('vimeo-id')
           var player = new Vimeo.player('video-vimeo', {id : vimeoID})
           console.log(player)
       } 

    },
};
  


// WEBPACK FOOTER //
// ./scripts/routes/template-home.js